// 第1张
const imgAllA = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1722949348822/a1.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015852850/r3_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015937853/r3_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751251095899/r3-ups.png',
        h5: '',
    },
};
export const imgLocaleA: any = {
    us: imgAllA.NA,
    ca: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    ph: imgAllA.PH,
};

// 第2张
const imgAllB = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1722949348988/a2.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015884744/r3_plus_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015958676/r3_plus_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751251096279/r3p.png',
        h5: '',
    },
};
export const imgLocaleB: any = {
    us: imgAllB.NA,
    ca: imgAllB.NA,
    uk: imgAllB.UK,
    eu: imgAllB.EU,
    de: imgAllB.EU,
    fr: imgAllB.EU,
    it: imgAllB.EU,
    es: imgAllB.EU,
    ph: imgAllB.PH,
};

// 第3张
const imgAllC = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1722949348633/a3.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015903418/r3_max_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015976839/r3_max_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751251096132/r3mp.png',
        h5: '',
    },
};
export const imgLocaleC: any = {
    us: imgAllC.NA,
    ca: imgAllC.NA,
    uk: imgAllC.UK,
    eu: imgAllC.EU,
    de: imgAllC.EU,
    fr: imgAllC.EU,
    it: imgAllC.EU,
    es: imgAllC.EU,
    ph: imgAllC.PH,
};
